// extracted by mini-css-extract-plugin
export default {"historyListTable":"flTm"};